import { IOptionsWithTypes } from '@eventr/common'
import { useCallback, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { bs, useBoundStore } from '../../../state/bound.store'
export const useMatchTagsAndUsers = () => {
    const { wpUser, override } = useBoundStore(
        useShallow((s) => {
            return {
                wpUser: s.wpUser,
                override: s.override,
            }
        })
    )
    const userOrOverride = useMemo(() => {
        if (override) {
            return bs().getUserFromID(override)
        }
        return wpUser
    }, [wpUser, override])

    const matchTagsAndUser = useCallback(
        (tagOrUser: IOptionsWithTypes) => {
            if (tagOrUser === undefined) return false
            switch (tagOrUser.type) {
                case 'User':
                    return tagOrUser.option === userOrOverride?.id
                case 'Department':
                    return userOrOverride?.departmentTags?.includes(
                        tagOrUser.option as string
                    )
                case 'Group':
                    return userOrOverride?.groupTags?.includes(
                        tagOrUser.option as string
                    )
                default:
                    return false
            }
        },
        [userOrOverride]
    )
    return { matchTagsAndUser }
}
